"use client";

import React from "react";
import QuickContact from "@/components/common/QuickContact";
import BusinessBanner from "@/components/pageComponent/business/businessBanner";
import BusinessStartHere from "@/components/pageComponent/business/buisnessStartHere";
import PostGardueteDesk from "@/components/pageComponent/business/postGardueteDesk";
import Entrepreneurs from "@/components/pageComponent/business/entrepreneurs";
import EdWork from "@/components/pageComponent/business/edWork";
import Mentor from "@/components/pageComponent/business/mentor";
import UnderGraduate from "@/components/pageComponent/business/underGraduate";
// import GlobalHeader from "@/components/common/newCommonComponent/GlobalHeader";
import GlobalFooter from "@/components/common/newCommonComponent/GlobalFooter";
import GlobalHeaderNew from "@/components/common/newCommonComponent/GlobalHeaderNew";

const DesktopPage: React.FC = () => {
  return (
    <main className="flex flex-col items-center justify-between bg-white min-h-screen w-full">
      <div className="bg-[#191919] w-full blue_shadow z-[99]">
        <GlobalHeaderNew />
      </div>
      <BusinessBanner />
      <BusinessStartHere />
      <PostGardueteDesk />
      <Entrepreneurs />
      <EdWork />
      <Mentor />
      <UnderGraduate />
      <div className="w-full">
        <GlobalFooter />
      </div>
      <QuickContact />
    </main>
  );
};

export default DesktopPage;
